export class LoadProvincieINModel {
    codiRegione: string
}